import { formatUnits } from "@ethersproject/units";
import { decorateStrikePrices } from "../../utils/decorators";
import moment from "moment";

// export const isMarketsLoaded = (marketsMutableAttributesLoaded, marketsImmutableAttributesLoaded, tradesLoaded, lpTradesLoaded) => {
export const isMarketsLoaded = (marketsMutableAttributesLoaded, marketsImmutableAttributesLoaded) => {
  // return marketsMutableAttributesLoaded && marketsImmutableAttributesLoaded && tradesLoaded && lpTradesLoaded;
  return marketsMutableAttributesLoaded && marketsImmutableAttributesLoaded;
};

export const getMarkets = (
  marketsMutableAttributesData,
  marketsImmutableAttributesData,
  // tradesData,
  // lpTradesData,
  marketsMutableAttributesLoaded,
  marketsImmutableAttributesLoaded,
  // tradesLoaded,
  // lpTradesLoaded,
  settlementData,
  nonExpired
) => {
  // if (!isMarketsLoaded(marketsMutableAttributesLoaded, marketsImmutableAttributesLoaded, tradesLoaded, lpTradesLoaded)) {
  if (!isMarketsLoaded(marketsMutableAttributesLoaded, marketsImmutableAttributesLoaded)) {
    return [];
  }
  // handle immutable attributes
  marketsImmutableAttributesData = marketsImmutableAttributesData.map(market => {
    const decoratedStrikePrice = decorateStrikePrices(market.strikePrice, market.baseTokenDecimals);
    const readable = moment(new Date(market.expirationTime * 1000)).format("DD MMM YYYY");
    // const readable = new Date(market.expirationTime * 1000).toLocaleDateString("en-GB", {
    //   day: "numeric",
    //   month: "short",
    //   year: "numeric"
    // });
    // NOTE: for some reason, month is Sept not Sep,
    // check console on: https://jsfiddle.net/wo1ck5Ls/
    const readableFixed = readable.replace("Sept", "Sep");
    return {
      ...market,
      rawStrikePrice: decoratedStrikePrice ? decoratedStrikePrice.raw : null,
      normalizedStrikePrice: decoratedStrikePrice ? decoratedStrikePrice.normalized : null,
      printableStrikePrice: decoratedStrikePrice ? decoratedStrikePrice.printable : null,
      readableExpirationTime: readableFixed
    };
  });

  // handle mutable attributes
  let immutableAttributes;
  let returnData = marketsMutableAttributesData.map((market, i) => {
    immutableAttributes = marketsImmutableAttributesData[i];
    // const trades = tradesData
    //   .filter(td => td && td.marketId === market.marketId)
    //   .map(td => {
    //     const { timestamp, isBuy, transactionHash, size, baseAmount } = td;

    //     return {
    //       timestamp,
    //       isBuy,
    //       type: td.type,
    //       transactionHash,
    //       baseAmount: parseFloat(formatUnits(baseAmount.toString(), immutableAttributes.baseTokenDecimals)),
    //       optionAmount: parseFloat(formatUnits(size.toString(), 18))
    //     };
    //   });

    // const lpTrades = lpTradesData
    //   .filter(td => td && td.marketId === market.marketId)
    //   .map(td => {
    //     const { timestamp, isBuy, transactionHash, optionAmount, baseAmount } = td;

    //     return {
    //       timestamp,
    //       isBuy,
    //       transactionHash,
    //       baseAmount: parseFloat(formatUnits(baseAmount.toString(), immutableAttributes.baseTokenDecimals)),
    //       optionAmount: parseFloat(formatUnits(optionAmount.toString(), 18))
    //     };
    //   });

    // trades.sort((a, b) => {
    //   return a.timestamp - b.timestamp;
    // });
    // lpTrades.sort((a, b) => {
    //   return a.timestamp - b.timestamp;
    // });

    // TODO: v2 tema za razmisljanje za Slavena i mene - dve opcije:
    // a) radimo kako jeste - ucitavamo isSettled za svaki market pomocu wrapper contracta i onda se subscribujemo na sve nove settlement eventove
    // b) ucitavamo sve prethodne settlement eventove i subscribujemo se na sve nove, i ne moramo da citamo taj parametar kad ucitavamo markete jer ga imamo ovde
    // const isSettled = settlementData.find(
    //   data =>
    //     data.baseTokenAddress.toString() === immutableAttributes.baseTokenAddress.toString() &&
    //     data.underTokenAddress.toString() === immutableAttributes.underlyingTokenAddress.toString() &&
    //     data.expirationTime.toString() === immutableAttributes.expirationTime.toString()
    // );
    return {
      ...immutableAttributes,
      ...market,
      strikePrice: parseFloat(formatUnits(immutableAttributes.strikePrice.toString(), immutableAttributes.baseTokenDecimals)),
      // longPrice: market.longPrice,
      // openLongPrice: market.openLongPrice,
      // closeLongPrice: market.closeLongPrice,
      // openShortPrice: [market.openLongPrice, market.openShortPrice[1]],
      // closeShortPrice: [market.closeLongPrice.toString(), market.closeShortPrice[1]],
      minFee: parseFloat(formatUnits(market.minFee.toString(), 6)),
      maxFee: parseFloat(formatUnits(market.maxFee.toString(), 6)),
      steepness: parseFloat(formatUnits(market.steepness.toString(), 6)),
      openInterest: parseFloat(formatUnits(market.openInterest.toString(), 18)),
      requiredThreshold: parseFloat(formatUnits(market.requiredThreshold.toString(), 2)),
      liquidationThreshold: parseFloat(formatUnits(market.liquidationThreshold.toString(), 2)),
      penaltyBase: parseFloat(formatUnits(market.penaltyBase.toString(), 18)),
      liquidityInCurrentTick: parseFloat(formatUnits(market.liquidityInCurrentTick.toString(), 18)),
      // isSettled: isSettled ? true : false
      isSettled: market.isSettled
      // historicalData: {
      //   trades,
      //   lpTrades
      // }
    };
  });

  // if nonExpired is true, filter out expired markets
  if (nonExpired) {
    const currentTimestamp = Math.round(Date.now() / 1000);
    returnData = returnData.filter(market => currentTimestamp < parseInt(market.expirationTime) && !market.isSettled);
  }
  return returnData;
};

export const getMarketsHistoricalData = (
  marketsMutableAttributesData,
  marketsImmutableAttributesData,
  tradesData,
  lpTradesData,
  marketsMutableAttributesLoaded,
  marketsImmutableAttributesLoaded,
  tradesLoaded,
  lpTradesLoaded
) => {
  if (!(marketsMutableAttributesLoaded && marketsImmutableAttributesLoaded && tradesLoaded && lpTradesLoaded)) {
    return new Map();
  }
  const marketsHistoricalData = new Map();

  // handle immutable attributes
  marketsImmutableAttributesData = marketsImmutableAttributesData.map(market => {
    const decoratedStrikePrice = decorateStrikePrices(market.strikePrice, market.baseTokenDecimals);
    const readable = moment(new Date(market.expirationTime * 1000)).format("DD MMM YYYY");
    // const readable = .toLocaleDateString("en-GB", {
    //   day: "numeric",
    //   month: "short",
    //   year: "numeric"
    // });
    // NOTE: for some reason, month is Sept not Sep,
    // check console on: https://jsfiddle.net/wo1ck5Ls/
    const readableFixed = readable.replace("Sept", "Sep");
    return {
      ...market,
      rawStrikePrice: decoratedStrikePrice ? decoratedStrikePrice.raw : null,
      normalizedStrikePrice: decoratedStrikePrice ? decoratedStrikePrice.normalized : null,
      printableStrikePrice: decoratedStrikePrice ? decoratedStrikePrice.printable : null,
      readableExpirationTime: readableFixed
    };
  });

  // handle mutable attributes
  let immutableAttributes;
  marketsMutableAttributesData.forEach((market, i) => {
    immutableAttributes = marketsImmutableAttributesData[i];
    const trades = tradesData
      .filter(td => td && td.marketId === market.marketId)
      .map(td => {
        const { timestamp, isBuy, transactionHash, size, baseAmount } = td;
        return {
          timestamp,
          isBuy,
          type: td.type,
          // transactionHash,
          // baseAmount: parseFloat(formatUnits(baseAmount.toString(), immutableAttributes.baseTokenDecimals)),
          optionAmount: parseFloat(formatUnits(size.toString(), 18)),
          baseAmount: baseAmount
          // optionAmount: size
        };
      });
    const lpTrades = lpTradesData
      .filter(td => td && td.marketId === market.marketId)
      .map(td => {
        const { timestamp, isBuy, transactionHash, optionAmount, baseAmount } = td;
        return {
          timestamp,
          isBuy,
          // transactionHash,
          // baseAmount: parseFloat(formatUnits(baseAmount.toString(), immutableAttributes.baseTokenDecimals)),
          optionAmount: parseFloat(formatUnits(optionAmount.toString(), 18)),
          baseAmount: baseAmount
          // optionAmount: optionAmount
        };
      });
    trades.sort((a, b) => {
      return a.timestamp - b.timestamp;
    });
    lpTrades.sort((a, b) => {
      return a.timestamp - b.timestamp;
    });

    marketsHistoricalData.set(market.marketId, {
      trades,
      lpTrades
    });
  });
  return marketsHistoricalData;
};
